if (!customElements.get("store-switcher")) {
  class StoreSwitcher extends HTMLElement {
    constructor() {
      super();

      this.dropdown = this.querySelector(".store-switcher__dropdown");
      this.button = this.querySelector(".store-switcher__button");

      this.button?.addEventListener("click", () => {
        this.dropdown.classList.contains("store-switcher__dropdown--open")
          ? this.closeDropdown()
          : this.openDropdown();
      });

      // Close dropdown when clicking outside
      document.addEventListener("click", (event) => {
        if (!this.contains(event.target)) {
          this.closeDropdown();
        }
      });

      this.countrySelect = this.querySelector(
        ".store-switcher__country-select"
      );
    }

    openDropdown() {
      this.dropdown.classList.add("store-switcher__dropdown--open");
    }

    closeDropdown() {
      this.dropdown.classList.remove("store-switcher__dropdown--open");
    }

    openCountryOptions() {
      this.countryOptions.classList.remove("select-hide");
      this.countrySelected.classList.add("select-arrow-active");
    }

    closeCountryOptions() {
      this.countryOptions.classList.add("select-hide");
      this.countrySelected.classList.remove("select-arrow-active");
    }
  }
  customElements.define("store-switcher", StoreSwitcher);
}
